function roundCurrency(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;
}
/**
 * Price after a product promotion, never below zero. Same rule as the
 * server (lib/util/directSalePricing applySaleItemPromotion).
 * @function applyPromotion
 * @since 1.0.0
 */
export function applyPromotion(price, promotion) {
    if (!promotion) {
        return price;
    }
    const discounted = promotion.type === 'PERCENTAGE'
        ? price * (1 - promotion.value / 100)
        : price - promotion.value;
    return roundCurrency(Math.max(0, discounted));
}
/**
 * Promotional price when the product has active promotions: the lowest
 * resulting price, as the server charges. Null without promotion.
 * @function getPromotionPrice
 * @since 1.0.0
 */
export function getPromotionPrice(price, promotions) {
    if (price == null || !(promotions === null || promotions === void 0 ? void 0 : promotions.length)) {
        return null;
    }
    return Math.min(...promotions.map((promotion) => applyPromotion(price, promotion)));
}
